'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var DropDownCell = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(DropDownCell, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(DropDownCell);

  function DropDownCell() {
    _rollupPluginBabelHelpers.classCallCheck(this, DropDownCell);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(DropDownCell, [{
    key: "render",
    value: function render() {
      var classes = [].concat(_rollupPluginBabelHelpers.toConsumableArray(this.props.classNames), ['ds-atom-drop-down-cell']).join(' ');
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: classes
      }, this.props.children);
    }
  }]);

  return DropDownCell;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(DropDownCell, "propTypes", {
  classNames: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  children: PropTypes__default['default'].node.isRequired
});

_rollupPluginBabelHelpers.defineProperty(DropDownCell, "defaultProps", {
  classNames: []
});

module.exports = DropDownCell;
